import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';
import AOS from 'aos';
import 'aos/dist/aos.css';
import * as moment from "moment";

declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
@Pipe({
	name: 'orderBy'
})
export class HomeComponent implements OnInit {

	transform = orderBy;

	newsList: any = "";
	matchesnewList: any = "";
	seasontypeid: any = 6;
	matchesallrequest: any = {
		season_type_id: this.seasontypeid
	};
	upcomingmatchesList: any = "";
	pastmatchesList: any = "";
	livematchesList: any = "";
	livematcheList: any = "";
	livematcheListWomen: any = "";
	livematchesListWomen: any = "";
	playerManList: any = "";
	playerWomanList: any = "";
	playerAcademyList: any = "";
	playerCoachingList: any = "";
	evnetList: any = "";
	evnetsecList: any = "";
	videoList: any = "";
	homevideoList: any = "";
	sponsorsList: any = "";
	seasonList: any = "";
	playerWomenList: any = "";
	bannerList: any = "";
	adbannerList: any = "";
	bannerbottomList: any = "";
	cricketsList: any = "";

	matchesList: any = "";
	membershipList: any = "";
	main_tabid = 15;
	second_tabid = 7;
	livestatus: any = "Live";
	status: any = "Upcoming";
	paststatus: any = "Past";
	player: any = "Men";
	matchesrequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.status
	};
	upcomingmatchrequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.status
	}
	pastmatchrequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.paststatus
	}
	liverequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.livestatus
	};
	liverequestwomen: any = {
		series_type_id: this.second_tabid,
		matche_status: this.livestatus
	};

	//playerrequest: any = {};
	bannerrequest: any = {};
	eventrequest: any = {};
	newsrequest: any = {
		news_catagory_id: "",
	};
	videorequest: any = {
		video_catagory_id: 1
	};
	playerrequest = {
		team_type: this.player
	};
	constructor(private allpagesService: AllPageService,) { }
	slidematchConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 2,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidematchtwoConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 2,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidenewConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidevideoConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidegraceConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay:true,
		speed: 2000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideplayerxiConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidematchbookConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidematchreportConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidehomebannerConfig = {
		//dots: true,
		infinite: true,
		arrows:false,
		slidesToShow: 1,
		autoplay: true,
		speed: 500,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	ngOnInit() {

		this.allpagesService.getCricketdetailimage().then((data) => {
			this.cricketsList = data;
			//this.presidentgeneralList = data;
			console.log(this.cricketsList);
			
		});
		
		jQuery(".player-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".player-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".player-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");;
			}
			
		});

		jQuery('ul.stafftab li').click((e) => {
			var datarel = e.currentTarget.id;
			//console.warn(datarel);
			this.player = datarel;
			// this.playerrequest = {
			// 	team_type: this.player
			// };
			// this.loadplayerMan();
			
		});
		jQuery(".match-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".match-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".match-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");;
			}
			return false;
		});

		this.loadnews();
		this.loadvideo();
		this.loadmatches();
		this.loadplayerMan();
		this.loadBanner();
		this.loadAdBanner();
		this.loadmatchesupcoming();
		this.loadmatchespast();
		this.loadmatcheslive();
		this.loadmatcheslivewomen();
		this.loadeventfirst();
		this.loadeventsec();
		this.loadBannerbottom();
		this.loadmatchesnew();
		this.loadhomevideo();
		this.loadplayerCoaching();
		this.loadplayerAcademy();
		this.loadplayerWomen();

		this.allpagesService.getSeasontype().then((data) => {
			this.seasonList = data.data[0];
			//console.log(this.seasonList);

			setTimeout(() => {
				jQuery(".courses-name").click(function () {
					if (jQuery(this).hasClass('active')) {
					} else {
						var tabid = jQuery(this).attr('id');
						jQuery(".courses-name").removeClass('active');
						jQuery(this).addClass('active');
						jQuery(".course-main-content").removeClass('active');
						jQuery("#" + tabid + "-content").addClass("active");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-inner-detail .inner-name:first").addClass("active");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-inner-detail-content.inner-main-content:first").addClass("active");
					}
					return false;
				});

				jQuery(".inner-name").click(function () {
					if (jQuery(this).hasClass('active')) {
					} else {
						var tabid = jQuery(this).attr('id');
						jQuery(".inner-name").removeClass('active');
						jQuery(this).addClass('active');
						jQuery(".inner-main-content").removeClass('active');
						jQuery("#" + tabid + "-content").addClass("active");
						jQuery("#" + tabid + "-content").addClass("active");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
					}
					return false;
				});

				jQuery(".fixtures-name").click(function () {
					if (jQuery(this).hasClass('ok')) {
					} else {
						var tabid = jQuery(this).attr('id');
						jQuery(".fixtures-name").removeClass('ok');
						jQuery(this).addClass('ok');
						jQuery(".fixtures-main-content").removeClass('ok');
						jQuery("#" + tabid + "-content").addClass("ok");
					}
					return false;
				});

				jQuery('ul.maintab li a').click((e) => {
					var dataid = e.currentTarget.id;
					this.main_tabid = dataid;
					//console.log(this.main_tabid);
					this.matchesrequest = {
						series_type_id: this.main_tabid,
						matche_status: this.status
					};
					this.loadmatches();
				});

				jQuery('ul.subtab li a').click((e) => {
					var datastatus = e.currentTarget.id;
					this.status = datastatus;
					//console.log(this.status);
					this.matchesrequest = {
						series_type_id: this.main_tabid,
						matche_status: this.status
					};
					this.loadmatches();
				});
				jQuery('.popup-youtube').magnificPopup({
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,

					fixedContentPos: false
				});
			}, 1000);
		});


		

		jQuery(window).scroll(function () {
			var vidsection = jQuery('.homepage .latest-new-section').offset().top;
			var scroll = jQuery(window).scrollTop();
			//console.log(scroll);
			jQuery(".vector-overlay-inner img").css({
				transform: 'translate3d(0%, -' + (scroll / 180) + '%, 0) scale(' + (200 + scroll / 3) / 500 + ')'
			});
			if (jQuery(window).scrollTop() > vidsection) {
				var scrolls = jQuery(window).scrollTop();
				jQuery(".vector-overlay-inner img").css({
					opacity: 2.6 - (scrolls / 180) / 5
				});
			}
		});
		jQuery(window).scroll(function () {
			/*var vidsections = jQuery('.homepage .vector-section').offset().top;
			var scrollx = jQuery(window).scrollTop();

			if (scrollx > (vidsections - 200)) {
				jQuery('#video').get(0).play();
				jQuery('.vector-detail').addClass('readbox');
			}
			else if (scrollx > jQuery(vidsections + 300)) {

				jQuery('.vector-detail').removeClass('readbox');

			}*/

		});
		/*var vidsections = jQuery('.homepage .vector-section').offset().top;
		var scrollx = jQuery(window).scrollTop();
		if (jQuery(window).width() < 768) {
			if (scrollx > (vidsections + 500)) {
				jQuery('#video').get(0).play();
			}
		}*/


		// this.allpagesService.getEventtype().then((data) => {
		// 	this.evnetList = data;
		// 	console.warn(this.evnetList);
		// });

		this.allpagesService.getSponsors().then((data) => {
			this.sponsorsList = data.data[0];
			//console.log(this.sponsorsList);
		});

		this.allpagesService.getMembership().then((data) => {
			this.membershipList = data;
			console.log(this.membershipList);
		});


		AOS.init({
			duration: 2000,
			offset: 1200,
			useClassNames: true,
			initClassName: true,
			animatedClassName: 'animated',
		});

		jQuery(window).scroll(function () {
			// jQuery('#over-img').each(function(){
			// var section = jQuery(this).offset().top;
			// if(jQuery(window).scrollTop()>section){
			// 	jQuery('.vector-overlay').addClass('zoomin');	

			// }
			// });
			// jQuery('#over-img').each(function(){
			// var section = jQuery(this).offset().top;
			//   if (jQuery(window).scrollTop() >section) {
			// 	jQuery('.vector-section').addClass('fixed');
			//    }
			//    else (jQuery(window).scrollTop() >section) {
			// 	jQuery('.vector-section').removeClass('fixed');
			//    }
			// });
		});

	}

	loadeventfirst() {
		this.eventrequest = {
			slug: 'tickets'
		}
		let request = Object.assign({}, this.eventrequest);
		this.allpagesService.getEventtype(request).then((data: any) => {
			this.evnetList = data;
			console.warn(this.evnetList);
		});
	}

	loadeventsec() {
		this.eventrequest = {
			slug: 'whats-on'
		}
		let request = Object.assign({}, this.eventrequest);
		this.allpagesService.getEventtype(request).then((data: any) => {
			this.evnetsecList = data;
			console.warn(this.evnetsecList);
		});
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Home'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data;
			//console.log(this.bannerList);
		});
	}

	loadAdBanner() {
		this.bannerrequest = {
			title: 'Home Ad'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.adbannerList = data;
			//console.log(this.bannerList);
		});
	}

	loadhomevideo() {
		this.bannerrequest = {
			title: 'Home Video'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.homevideoList = data.data[0];
			console.log(this.homevideoList);
		});
	}

	loadBannerbottom() {
		this.bannerrequest = {
			title: 'Home Bottom'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerbottomList = data.data[0];
			//console.log(this.bannerList);
		});
	}

	loadplayerCoaching() {
		this.playerrequest.team_type = 'Coaching_Staff';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerCoachingList = data;
			//console.log(this.playerManList);
		});
	}

	loadplayerMan() {
		this.playerrequest.team_type = 'Men';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerManList = data;
			//console.log(this.playerManList);
		});
	}

	loadplayerAcademy() {
		this.playerrequest.team_type = 'Academy';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerAcademyList = data;
			//console.log(this.playerManList);
		});
	}

	loadplayerWomen() {
		this.playerrequest.team_type = 'Women';
		let request = Object.assign({}, this.playerrequest);
		this.allpagesService.getPlayerlist(request).then((data: any) => {
			this.playerWomenList = data;
			//console.log(this.playerManList);
		});
	}

	loadmatches() {
		let request = Object.assign({}, this.matchesrequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.matchesList = data;
			//console.warn(this.matchesList);
		});
	}

	loadnews() {
		let request = Object.assign({}, this.newsrequest);
		this.allpagesService.getNewsListing(request).then((data: any) => {
			this.newsList = data;
			//console.log(this.newsList);
		});
	}

	loadvideo() {
		let request = Object.assign({}, this.videorequest);
		this.allpagesService.getVideoListing(request).then((data: any) => {
			this.videoList = data;
			//console.log(this.videoList);
		});
	}


	loadmatchesupcoming() {
		let request = Object.assign({}, this.upcomingmatchrequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.upcomingmatchesList = data;
			//console.warn(this.upcomingmatchesList);
		});
	}


	loadmatchespast() {
		let request = Object.assign({}, this.pastmatchrequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.pastmatchesList = data;
			//console.warn(this.pastmatchesList);
		});
	}

	loadmatcheslive() {
		let request = Object.assign({}, this.liverequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.livematcheList = data;
			this.livematchesList = data.data[0];

			console.warn(this.livematchesList);
		});
	}
	loadmatcheslivewomen() {
		let request = Object.assign({}, this.liverequestwomen);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.livematcheListWomen = data;
			this.livematchesListWomen = data.data[0];

			console.warn(this.livematcheListWomen);
		});
	}

	loadmatchesnew() {

		let request = Object.assign({}, this.matchesallrequest);
		this.allpagesService.getMatcheslistnew(request).then((data: any) => {
			this.matchesnewList = data;
			setTimeout(() => {
				jQuery(".courses-name").click(function () {
					if (jQuery(this).hasClass('active')) {
					} else {
						var tabid = jQuery(this).attr('id');
						jQuery(".courses-name").removeClass('active');
						jQuery(this).addClass('active');
						jQuery(".course-main-content").removeClass('active');
						jQuery("#" + tabid + "-content").addClass("active");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-inner-detail .inner-name:first").addClass("active");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-inner-detail-content.inner-main-content:first").addClass("active");
					}
					return false;
				});

				jQuery(".inner-name").click(function () {
					if (jQuery(this).hasClass('active')) {
					} else {
						var tabid = jQuery(this).attr('id');
						jQuery(".inner-name").removeClass('active');
						jQuery(this).addClass('active');
						jQuery(".inner-main-content").removeClass('active');
						jQuery("#" + tabid + "-content").addClass("active");
						jQuery("#" + tabid + "-content").addClass("active");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
						jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
					}
					return false;
				});

				jQuery(".fixtures-name").click(function () {
					if (jQuery(this).hasClass('ok')) {
					} else {
						var tabid = jQuery(this).attr('id');
						jQuery(".fixtures-name").removeClass('ok');
						jQuery(this).addClass('ok');
						jQuery(".fixtures-main-content").removeClass('ok');
						jQuery("#" + tabid + "-content").addClass("ok");
					}
					return false;
				});

			}, 1000);

			console.warn(this.matchesnewList);
		});

	}


}
